import styled from "styled-components";

import { MOBILE_BREAKPOINT } from "@ryde/theme";

import { MenuDrawerHeaderStyled } from "../drawer";

export const NotificationHeaderStyled = styled(MenuDrawerHeaderStyled)`
  .NotificationMore {
    margin-inline-start: 10px;
    margin-inline-end: 30px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    .NotificationHeader-MoreLink {
      margin-inline-start: auto;
      order: 2;
    }
    .NotificationMore {
      margin-inline-start: 0;
      margin-inline-end: 0;
    }

    .DrawerCloseIconButton {
      order: 3;
    }
  }

  ${MenuDrawerHeaderStyled}
`;
